import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const CreditsUIContext = createContext();

export function useCreditsUIContext() {
  return useContext(CreditsUIContext);
}

export function CreditsUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async input => {
    // remove "?" from query string
    const query = input.slice(1);

    api
      .get(`/credits?${query}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <CreditsUIContext.Provider value={value}>{children}</CreditsUIContext.Provider>;
}
